var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 7.04201C10.3516 5.56337 8.2144 4.74695 6 4.75001C4.948 4.75001 3.938 4.93001 3 5.26201V19.512C3.96362 19.172 4.97816 18.9989 6 19C8.305 19 10.408 19.867 12 21.292M12 7.04201C13.6483 5.56328 15.7856 4.74686 18 4.75001C19.052 4.75001 20.062 4.93001 21 5.26201V19.512C20.0364 19.172 19.0218 18.9989 18 19C15.7856 18.997 13.6484 19.8134 12 21.292M12 7.04201V21.292",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionIcon);
export default __webpack_public_path__ + "static/media/IntroductionIcon.81ecaa576a28b68ea939b7fbdf0e6510.svg";
export { ForwardRef as ReactComponent };